import Button from "@/components/button/Button"
import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import BookDemoButton from "@/components/website/book-demo-button/BookDemoButton"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { useBreakpoint } from "@/hooks/useBreakpoint"
import { CLIENT_LOGO_SLIDES } from "@/pages/website-landing/components/client-logos/clientLogos"
import SliderButtons from "@/pages/website-landing/components/slider-buttons/SliderButtons"
import { CLIENT_REVIEWS } from "@/pages/website-landing/home/sections/customer-reviews/clientReviews"
import ReviewCard from "@/pages/website-landing/home/sections/customer-reviews/review-card/ReviewCard"
import { EASETECH } from "@/utilities/global-variables"
import { Carousel, Col, Row } from "antd"
import { CarouselRef } from "antd/es/carousel"
import { FC, useRef } from "react"
import { useNavigate, useParams } from "react-router"
import "./CustomerReviews.less"

const { Title, Paragraph, Text } = WebsiteTypography

export type ReviewItemType = {
  id: string
  title: string
  description: string
  name: string
  date: string
  rate: number
}
export type LogoItemType = {
  id: string
  logoUrl: string
}

const CustomerReviews: FC = () => {
  const { openDarkModal } = useModalDarkContext()
  const navigate = useNavigate()
  const { org } = useParams()
  const currentOrgSlug = org || EASETECH
  const platformType = "wayleave"

  const onClick = () => {
    navigate(`/${currentOrgSlug}/auth/${platformType}/client`)
  }

  const sliderRef = useRef<CarouselRef | null>(null)
  const { xs, sm, md, lg, xl, xxl } = useBreakpoint()

  const reviewSliderSettings = {
    focusOnSelect: false,
    infinite: true,
    speed: 500,
    slidesToShow: xxl ? 3.6 : xl ? 3 : lg ? 2.7 : md ? 2.2 : sm ? 2 : xs ? 1 : 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
  }
  const logoSliderSettings = {
    infinite: true,
    slidesToShow: xl ? 8 : md ? 3.6 : sm ? 2.4 : xs ? 2.5 : 2,
    slidesToScroll: 1,
    swipeToSlide: true,
    dots: false,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 3000,
    cssEase: "linear",
    pauseOnHover: true,
  }

  return (
    <div className={"reviews-wrapper"}>
      <div className={"reviews-content"}>
        {/*Navigation-arrows block*/}

        <div className={"container"}>
          <Row className={"reviews-section-header"} justify={"center"}>
            <Col span={24}>
              <Title
                level={!(xxl || xl || lg || md || sm) ? 3 : 2}
                className={"reviews-section-title"}
                style={{ width: "100%" }}
              >
                <span className={"w300"}>{"Built for teams processing "}</span>
                <span className={"bold orange"}>{"high\nvolumes "}</span>
                <span className={"w300"}>{"of applications. "}</span>
              </Title>
            </Col>
          </Row>
        </div>

        {/*Sliders*/}
        <div className={"slider-wrapper"}>
          <Carousel ref={sliderRef} {...reviewSliderSettings} className={"slider-container"}>
            {CLIENT_REVIEWS.map(it => (
              <div className={"review-card-wrapper"} key={it?.id}>
                <ReviewCard
                  it={it}
                  onClick={() =>
                    openDarkModal({
                      type: "full-review",
                      contentReviewCard: it,
                      isLogo: false,
                      mode: "default",
                      width: "width900",
                    })
                  }
                />
              </div>
            ))}
          </Carousel>

          <div className={"reviews-slider-buttons"}>
            <SliderButtons slider={sliderRef} />
          </div>

          <Carousel {...logoSliderSettings} className={"slider-logo-container"}>
            {CLIENT_LOGO_SLIDES.map((logo, index) => (
              <div className={"logo-card"} key={`${logo.name}-${index}`}>
                <div className={"logo-img-wrapper"}>
                  <img src={logo.src} alt={logo.name} loading={"lazy"} decoding={"async"} />
                </div>
              </div>
            ))}
          </Carousel>
        </div>
      </div>

      <div className={"container"}>
        <div className={"customer-reviews-orange-box"}>
          <Title color={"white"} level={xxl || xl || lg || md ? 2 : 3} centered style={{ paddingBottom: 16 }}>
            <span className={"w300"}>{"Ready to "}</span>
            <span className={"bold"}>{"simplify "}</span>
            <span className={"w300"}>{"your wayleave process? "}</span>
          </Title>

          <Paragraph color={"white"} size={xxl || xl || lg || md ? "lg" : "md"} centered style={{ paddingBottom: 32 }}>
            <span className={"w300"}>{"See how Easetech can help your team "}</span>
            <span className={"bold"}>{"process more applications, faster\n"}</span>
            <span className={"w300"}>{"and with "}</span>
            <span className={"bold"}>{"less effort."}</span>
          </Paragraph>

          <div className={"btn-wrapper"}>
            <BookDemoButton type={"darkBlue"} />
          </div>

          {/*<Paragraph style={{ paddingTop: 16, paddingBottom: 8 }}>{"Or"}</Paragraph>*/}

          {/*<Button btnType={"text"} textColor={"white"}>*/}
          {/*  <Text size={xxl || xl || lg || md ? "lg" : "md"} weight={"w300"} underline={true} onClick={onClick}>*/}
          {/*    {xxl || xl || lg || md || sm ? "Try it yourself — Submit an application for free" : "Submit for free"}*/}
          {/*  </Text>*/}
          {/*</Button>*/}
        </div>
      </div>
    </div>
  )
}

export default CustomerReviews
